module.exports = __webpack_public_path__ + "img/eye-cancelled.71553d81.svg";